import React from 'react';
import { Button, Stack, Text } from '@chakra-ui/react';
import { ROUTER_PATHS } from '~/constants';

export const EvaluateServiceSent: React.VFC = () => {
  return (
    <Stack gridGap={3} alignItems="center">
      <Stack alignItems="center">
        <Text fontSize="16px">Obrigado pela avaliação!</Text>
        <Text fontSize="16px">
          Sua opinião é super importante para a gente melhorar ainda mais.
        </Text>
      </Stack>
      <Button
        maxW="fit-content"
        color="white"
        background="gray.900"
        _hover={{
          bgColor: 'black',
        }}
        href={ROUTER_PATHS.PORTAL.TECHNICAL_SUPPORT}
        as="a"
      >
        Novo atendimento
      </Button>
    </Stack>
  );
};
